import React from 'react';
import Contact from './Contact';

const ContactPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      <Contact />
    </div>
  );
};

export default ContactPage;
